var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-checkbox-group",on:{"change":_vm.handleChange}},[(_vm.hasSelectAll)?_c('r-checkbox',{attrs:{"checked":_vm.allChecked,"indeterminate":_vm.indeterminate},on:{"click":_vm.handleSelectAllChange}},[_c('r-text',[_vm._v(" <"+_vm._s(_vm.$t('select_all'))+"> ")])],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }